import { type CanonicalEnvironment, isProductionEnvironment } from '../../../shared/environment';

/**
 * Environment-specific configurations for ViewJob app
 */

export interface EnvironmentConfig {
    profileBaseUrl: string;
    rezcowBaseUrl: string;
    resumeBaseUrl: string;
}

const PROD_CONFIG: EnvironmentConfig = {
    profileBaseUrl: 'https://profile.indeed.com',
    rezcowBaseUrl: 'https://resumecontacts.indeed.com',
    resumeBaseUrl: 'https://resumes.indeed.com',
};

const QA_CONFIG: EnvironmentConfig = {
    profileBaseUrl: 'https://profile.qa.indeed.net',
    rezcowBaseUrl: 'https://rezcow.sandbox.qa.indeed.net',
    resumeBaseUrl: 'https://resumes.sandbox.qa.indeed.net',
};

export const getEnvironmentConfig = (
    buildEnvironment: CanonicalEnvironment | undefined,
): EnvironmentConfig => {
    return isProductionEnvironment(buildEnvironment ?? 'prod')
        ? PROD_CONFIG
        : QA_CONFIG;
};
